module.exports = __webpack_public_path__ + "dbb1623f2a2bcf088f45e7c5a4eee71f.svg";